import { AfterViewInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import { FormArray } from '@angular/forms';
import { initDropdownFilter } from '@app/helpers/scripts';
import { IDataGrouped } from '@app/interfaces/idata-grouped';
import { BenefitIndexPipe } from '@app/pipes/benefit-index.pipe';
import { BenefitNamePipe } from '@app/pipes/benefit-name.pipe';
import { TicIndexPipe } from '@app/pipes/tic-index.pipe';
import { TicNamePipe } from '@app/pipes/tic-name.pipe';
import { TicSpecialtyIndexPipe } from '@app/pipes/ticSpecialty-index.pipe';
import { TicSpecialtyNamePipe } from '@app/pipes/ticSpecialty-name.pipe';

@Component({
  selector: 'form-group-checkbox-multi-group',
  templateUrl: './form-group-checkbox-multi-group.component.html',
  styleUrls: ['./form-group-checkbox-multi-group.component.css']
})
export class FormGroupCheckboxMultiGroupComponent implements AfterViewInit {

  @Input() controlArray: FormArray;
  @Input() id: string = '';
  @Input() placeholder: string = '';
  @Input() title: string = '';
  @Input() placeholderSearch: string = '';
  @Input() dataSelectLabel: Array<any> = [];
  @Input() dataSelectGroup: Array<IDataGrouped> = [];
  @Input() pipe: 'tic' | 'benefit' | 'ticSpecialty' | null = null;

  public pipeIndex: any = null;
  public pipeName: any = null;

  constructor() { }

  ngOnInit(): void {

    switch (this.pipe) {
      
      case 'tic':
        this.pipeIndex = TicIndexPipe;
        this.pipeName = TicNamePipe;
        break;
      
      case 'ticSpecialty':
        this.pipeIndex = TicSpecialtyIndexPipe;
        this.pipeName = TicSpecialtyNamePipe;
        break;

      case 'benefit':
        this.pipeIndex = BenefitIndexPipe;
        this.pipeName = BenefitNamePipe;
        break;
    }
  }


  ngAfterViewInit() {
    initDropdownFilter(this.id);
  }
}
